import { useState, useEffect, DependencyList } from 'react';

export function useEffectSubsequent(effect: () => void, additionalDeps?: DependencyList): void {
  const [firingForTheFirstTime, setFiringForTheFirstTime] = useState(true);

  useEffect(() => {
    if (firingForTheFirstTime) {
      effect();
    }
    setFiringForTheFirstTime(false);
  }, [...additionalDeps]);
}
